import { extractTextFromQuery } from '../../../utils/query';
import { school_agencyName_$ilike_includes } from '../../../utils/query-helpers';

export default {
  param: extractTextFromQuery,
  query: function (text) {
    const words = text.trim().split(' ');

    if (text) {
      return {
        ...school_agencyName_$ilike_includes(words)
      }
    }
  }
}
